import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "grid-layout" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cv.interests')), 1),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interests, (int, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass([`item-${i + 1}`, "item"]),
            key: i
          }, [
            _createElementVNode("img", {
              src: require('@/assets/interests/' + int.image + '.jpg')
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(int.name), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(int.description), 1)
            ])
          ], 2))
        }), 128))
      ])
    ])
  ], 64))
}